import { css } from '@emotion/css';

export const canvas = ({ width, height }) => css`
  label: score-color-legend-canvas;
  width: ${width}px;
  height: ${height}px;
`;
